// extracted by mini-css-extract-plugin
export default {"footer_cotainer":"Footer_footer_cotainer__EM+42","footer_main":"Footer_footer_main__RIVBV"};